import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { takeUntil, finalize } from 'rxjs/operators';

@Injectable()
export class CancelStaleGetInterceptor implements HttpInterceptor {
  private pending = new Map<string, Subject<void>>();

  // Piloto: solo Orden de Servicio. Se amplía por fase (ver spec) hasta cubrir
  // todo /api y luego se elimina este filtro por completo.
  // private static readonly SCOPED_PREFIXES: string[] = [
  //   '/api/orden-servicio',
  // ];

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.method !== 'GET' /*|| !this.isScoped(request.url)*/) {
      return next.handle(request);
    }

    const key = request.url.split('?')[0];
    // console.log('[CancelStaleGetInterceptor] GET en alcance:', request.urlWithParams);

    if (this.pending.get(key)) {
      // console.log('[CancelStaleGetInterceptor] cancelando petición previa a:', key);
      this.pending.get(key)?.next();
    }

    const cancel = new Subject<void>();
    this.pending.set(key, cancel);

    return next.handle(request).pipe(
      takeUntil(cancel),
      finalize(() => {
        // console.log('[CancelStaleGetInterceptor] finaliza (completa o cancelada):', request.urlWithParams);
        if (this.pending.get(key) === cancel) {
          this.pending.delete(key);
        }
      })
    );
  }

  // private isScoped(url: string): boolean {
  //   return CancelStaleGetInterceptor.SCOPED_PREFIXES.some(prefix => url.includes(prefix));
  // }
}
